import * as React from 'react';
import { observer } from 'mobx-react';
import { FileUploadForm } from '../../components/forms';

// Styles
const s = require('./ShippingListUploadForm.css');

// Props
interface IShippingListUploadFormProps {
    onFilesChange: (files: FileList) => void;
}

// Component
@observer
export class ShippingListUploadForm extends React.Component<IShippingListUploadFormProps, {}> {
    render() {
        return (
            <div>
                <FileUploadForm
                    onChange={this.handleFileChange}
                    className={s.form}
                    label="Upload shipping list CSV file"
                    acceptedExtensions="csv"
                    multiple={false}
                />
            </div>
        );
    }

    private handleFileChange = (files: FileList) => {
        if (this.props.onFilesChange) {
            this.props.onFilesChange(files);
        }
    };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/internal/ShippingListUploadForm.tsx